import { LazyLoad } from 'features/common/ui/LazyLoad'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'
import { lazy } from 'app/lazy'
import RequireFeatureFlag from 'app/ui/RequireFeatureFlag'
import { FeatureFlag } from 'app/ui/useFeatureFlag'

const AiAgentsPage = lazy(() => import('./AiAgentsPage/AiAgentsPage'))

const routes = {
  path: 'ai-agents',
  element: (
    <LazyLoad>
      <AuthenticatedRoute
        element={
          <RequireFeatureFlag flag={FeatureFlag.GenAIV1}>
            <AiAgentsPage />
          </RequireFeatureFlag>
        }
        allowGuestAccess
      />
    </LazyLoad>
  )
}

export default routes
